import { useState, useEffect, useMemo } from 'react';
import { useSearchParams } from '@framework/next/navigation';
import isEqual from 'lodash/isEqual';
import {
  IMarketStatsBasePayload,
} from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketStat';
import getStatsFilterFromQuery from '@/creditflowresearch/application/ArticlesAndStats/Stats/serverSide/getStatsFilterFromQuery';

const useStatsTileFilter = (initialPayload: IMarketStatsBasePayload): IMarketStatsBasePayload => {
  const searchParams = useSearchParams();
  const markets = searchParams.get('markets');
  const segments = searchParams.get('segments');
  const products = searchParams.get('products');
  const regions = searchParams.get('regions');

  const [statsPayload, setStatsPayload] = useState<IMarketStatsBasePayload>(initialPayload);

  const computedFilter = useMemo(
    () => getStatsFilterFromQuery({ products, regions, markets, segments }),
    [products, regions, markets, segments],
  );

  useEffect(() => {
    setStatsPayload((prev) => {
      if (isEqual(prev.filter, computedFilter)) {
        return prev;
      }

      return { ...prev, filter: computedFilter };
    });
  }, [computedFilter]);

  return statsPayload;
};

export default useStatsTileFilter;
